export default {
  entityRegisterDeatil: {
    title: "",
    component: () =>
      import("@/mods/warehouse/entityRegister/detailView/EntityRegisterDeatil"),
  },
};
